
import { BaseComponent } from '@/decorators';
import { Component } from 'vue-property-decorator';
import api from '@/utils/api'
import CheckForm from './Check.vue'
import Config from '@/utils/config';
import DB from '@/utils/api/DB';
import IQuill from '@/layout/components/quill/index.vue'
import { InputNumber } from 'view-design';


@Component({
    components: { CheckForm,IQuill }
})
export default class DocIndex extends BaseComponent {



    User = DB.Get('user.info');
    mode = '待处理';
    Donner = new Array<any>();
    Model = {
        title: null,
        source: 0,
        priority: 1,
        unit: null,
        remark: '',
        files: '',
        checkers: '',
        weHao: ''
    }
    Title = "文件传阅";
    Cols = [
        // { title: '文件编号', slot: 'number', minWidth: 90, maxWidth: 120, show: true },
        { title: '文件标题', slot: 'title', minWidth: 300, maxWidth: 420, show: true },
        { title: '附件', slot: 'files', minWidth: 340, show: true, },
        { title: '文号', slot: 'weHao', minWidth: 150,maxWidth: 300, show: true,},
        { title: '文件来源', slot: 'source', minWidth: 90, maxWidth: 130, show: true },

        { title: '发文单位', slot: 'unit', minWidth: 130,  show: true },
         { slot: 'priority', title: '流程类型', minWidth: 108, maxWidth: 108 },
        { slot: 'status', title: '状态', minWidth: 120, maxWidth: 120, },
        { title: '传阅人员', slot: 'checkers', minWidth: 340,show: true },
        { title: '分办人员', slot: 'donners', minWidth: 240,show: true },
        
       
        // { slot: 'relation', minWidth: 108, maxWidth: 108, title: '关系' },
        { title: '创建时间', slot: 'createdTime', minWidth: 180, maxWidth: 180, show: true },
        { slot: 'action', title: '操作', minWidth: 145, maxWidth: 145,fixed:'right'},
    ];
    Loading = true;
    List = new Array<any>();


    Archive(row:any){
        if(row.state!=2){
            this.$Notice.error({ title: '未完成的传阅无法归档' });
        }
        this.$Modal.confirm({
            title: '归档确认',
            content: '文档传阅归档后，则无法打印审批单，确认归档吗？',
            onOk: async () => {
                let res = await api.Doc.Archive(row.id);
                if (res.status == 200 && res.data) {
                    await this.Init();
                    this.$Notice.success({ title: '归档成功' });
                    this.ShowDrawer = false;
                } else {
                    this.$Notice.error({ title: '归档失败' });
                }

            }
        });
    }


    async mounted() {
        await this.Init();
    }

    CanDownload(row:any){
        if(row.state==3)
            return false;
        return row.status != 2 && row.state < 2 || this.User.role.code.toUpperCase()=='DOC-ARCHIVE';
    }

    async Init() {
        this.mode = '待处理';
        if (this.User.role.code.toUpperCase()=='DOC-ARCHIVE'){
            this.mode = '全部';
        }
        
        this.Query = { name: '' ,title:'',number:''};
        this.ChangeMode(this.mode);
        this.Model = {
            title: null,
            source: 0,
            priority: 1,
            unit: null,
            remark: '',
            files: '',
            checkers: '',
            weHao: ''
        };
        this.IsEdit = false;
        this.Row = null;
        this.$refs.PageView.showModal = false;
        this.InitPager();
    }
    async ChangeMode(e: string) {
        if (e == '待处理')
            this.Query.mode = 0;
        if (e == '已处理')
            this.Query.mode = 1;
        if (e == '我发起的')
            this.Query.mode = 2;
        if (e == '全部')
            this.Query.mode = 3;
        await this.FetchData();
    }

    async FetchData() {
        this.Loading = true;
        let res = await api.Doc.Query(this.Pager, this.Query);
        if (res.status == 200) {
            this.List = [...res.data.data];
            this.Pager.total = res.data.count;
            this.Loading = false;
        }
    }

    async Save() {
        if (!this.Model.title) {
            this.$Notice.error({ title: '请输入文件标题' });
            return;
        }
        if (!this.Model.source) {
            this.$Notice.error({ title: '请选择文件来源' });
            return;
        }
        if (!this.Model.priority) {
            this.$Notice.error({ title: '请选择紧急程度' });
            return;
        }
        if (!this.Model.unit) {
            this.$Notice.error({ title: '请输入发文单位' });
            return;
        }
        // if (!this.Model.weHao) {
        //     this.$Notice.error({ title: '请输入文号' });
        //     return;
        // }

        if (this.Model.checkers == '' || this.Model.checkers.length == 0) {
            this.$Notice.error({ title: '请选择传阅人员' });
            return;
        }
        if (this.Model.files == '' || !this.Model.files) {
            this.$Notice.error({ title: '请选择上传的文件' });
            return;
        }
        let res;
        if (this.IsEdit) {
            try {
                res = await api.Doc.Edit({ id: this.Row.id, ...this.Model });

            } catch (error: any) {
                this.$Notice.error({ title: error.message });
                return;
            }

        } else {
            res = await api.Doc.Create(this.Model);
        }

        if (res.status == 200 || res.status == 201) {
            this.$Notice.success({ title: '保存成功!' });
            await this.Init();
        }
    }
    async Publish() {
        let payload = { id: this.Row.id, remark: this.Remark };
        let res = await api.Doc.Publish(payload);
        if (res.status == 200 && res.data) {
            this.$Notice.success({ title: '操作成功!' });
            this.CloseCheck();
            await this.Init();
        }
    }

     async Do() {
        let payload = { id: this.Row.id, remark: this.Remark };
        let res = await api.Doc.Do(payload);
        if (res.status == 200 && res.data) {
            this.$Notice.success({ title: '操作成功!' });
            this.CloseCheck();
            await this.Init();
        }
    }


    async Publish2() {
        let payload = { id: this.Row.id, remark: this.Remark,donners : [...this.Donner] };

        if (this.Donner.length==0){
            this.$Modal.confirm({
                title: '提示',
                content: '文档传阅未选择分办人员，确认提交吗？',
                onOk: async () => {
                    let res = await api.Doc.Publish2(payload);
                    if (res.status == 200 && res.data) {
                        this.$Notice.success({ title: '操作成功!' });
                        this.CloseCheck();
                        await this.Init();
                    }

                }
            });
        }else{
            let res = await api.Doc.Publish2(payload);
            if (res.status == 200 && res.data) {
                this.$Notice.success({ title: '操作成功!' });
                this.CloseCheck();
                await this.Init();
            }
        }
    }

    async Reject() {
        if (!this.Remark) {
            this.$Message.error('请输入驳回原因');
            return;
        }
        let payload = { id: this.Row.id, remark: this.Remark };
        let res = await api.Doc.Reject(payload);
        if (res.status == 200 && res.data) {
            this.$Notice.success({ title: '操作成功!' });
            this.CloseCheck();
            await this.Init();
        }
    }

    OpenCheck(row: any) {
        this.Row = { ...row };
        this.ShowDrawer = true;
        // this.Remark = row.steps.find((s:any)=>s.userID== this.UserID).content;
    }
    CloseCheck() {
        this.ShowDrawer = false;
        this.Remark = '';
        this.Row = null;
    }
    OpenCancelModal(id: any) {
        this.$Modal.confirm({
            title: '提示',
            content: '当前申请已在流程中，确认是否撤销当前申请？',
            onOk: async () => {
                let res = await api.Doc.Cancel(id);
                if (res.status == 200 && res.data) {
                    await this.Init();
                    this.$Notice.success({ title: '撤销成功' });
                } else {
                    this.$Notice.error({ title: '撤销失败' });
                }

            }
        });
    }
    OpenEditModal(row: any) {
        this.$refs.PageView.showModal = true;
        this.IsEdit = true;
        this.Model = { ...row };
        this.Row = { ...row };
        this.Title = "编辑文件传阅";
    }
    OpenModal() {
        this.$refs.PageView.showModal = true;
        this.Title = "文件传阅";
    }
    ovdc(e:boolean){
        if(e){
            console.log(this.Row);
            this.Donner = this.Row.donnerLevels.filter((x:any)=>x.departmentID==this.User.departmentID).map((x:any)=>x.donnerID);
        }else{
            this.Row = null;
            this.Donner = new Array<any>();
        }
    }
    OVC(e: boolean) {
        if (e) {
            if(this.IsEdit){
                this.Model.checkers = this.Row.steps.map((x:any)=>x.userID);
                this.$refs.iCheckers.SetDefaultUser(this.Model.checkers);
            }
        } else {
            this.$refs.iCheckers.Clear();
            this.Model = {
                title: null,
                source: 0,
                priority: 1,
                unit: null,
                remark: '',
                files: '',
                checkers: '',
                weHao: ''
            }
            this.$refs.uploader.clearFiles();
            this.Row = null;
            this.IsEdit  = false;
            this.$refs.quill.clear();
        }
       
    }



    FinishUploadFiles(res: any) {
        if (res.status == 200) {
            let array = this.Model.files == '' ? new Array<string>() : this.Model.files.split(/,/);

            array.push(res.data);

            this.Model.files = array.join(',');
        }
    }

    RemoveFile(file:any, fileList:any){
       
        let array = this.Model.files == '' ? new Array<string>() : this.Model.files.split(/,/);
        array = array.filter((f)=>f!=file.name);

        this.Model.files = array.join(',');
       //  console.log(this.Model.files);
    }
    

    Action = `${Config.BASE_API}api/File/doc`;
    Folder = `${Config.BASE_UPLOAD}/doc`;


    
    getFile(flow:any,file:string) : string {
        var year = new Date(flow.createdTime).getFullYear();
        var month = new Date(flow.createdTime).getMonth()+1;
        return `${this.Folder}/${year}-${month}/${file}` ;
    }
    

}
